import { __assign } from "tslib";
import React from 'react';
import Lottie from 'react-lottie-player';
import cloudAnimation from './data/nubion.json';
var styles = {
  container: function container(loaderBackground, loaderZIndex, containerStyles) {
    return __assign({
      background: loaderBackground ? loaderBackground : 'rgba(2, 18, 21, 0.8)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backdropFilter: 'blur(0.313rem)',
      position: 'absolute',
      zIndex: loaderZIndex ? loaderZIndex : 9999,
      inset: 0,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    }, containerStyles);
  }
};

var Loader = function Loader(_a) {
  var lottieWidth = _a.lottieWidth,
      lottieHeight = _a.lottieHeight,
      loaderBackground = _a.loaderBackground,
      loaderZIndex = _a.loaderZIndex,
      animationData = _a.animationData,
      children = _a.children,
      containerStyles = _a.containerStyles;
  return React.createElement("div", {
    id: 'ionLoaderContainer',
    style: styles.container(loaderBackground, loaderZIndex, containerStyles)
  }, children, React.createElement(Lottie, {
    style: {
      width: lottieWidth ? lottieWidth : '10rem',
      height: lottieHeight ? lottieHeight : undefined
    },
    loop: true,
    animationData: animationData ? animationData : cloudAnimation,
    play: true,
    speed: 1
  }));
};

export { Loader };